module.exports = __webpack_public_path__ + "static/media/0327_IMG_LES_ENSEIGNES_LA_CAVE_LETTRE_A_LETTRE.5ddd54de.png";